import instance from "./instance.js";
import { base, python } from "./config.js";
import { message } from "antd";
import qs from "qs";

/**
 * 上传文件分片
 * @param {Object} parm 请求参数
 * @param {File} parm.file 文件分片
 * @param {String} parm.task_id 任务id，每个完整的文件task_id应相同
 * @param {String} parm.chunk 分片编号
 * @returns
 */
export const UPLOAD_FILE_PATCH = async (parm) =>
  await instance.post(`${python}/file/upload/patch`, parm, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/**
 * 文件分片合并
 * @param {Object} parm 请求参数
 * @param {String} parm.task_id 任务id，每个完整的文件task_id应相同
 * @param {String} parm.chunks 分片数量
 * @param {String} parm.filename 文件名称
 * @returns
 */
export const UPLOAD_FILE_MERGE = async (parm) =>
  await instance.post(`${python}/file/upload/merge`, parm, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
